import { AbstractSidebar } from "../../Sidebar/Abstract";
import { calculateTax } from "../Helper/CartItemProperties";
import { DATA_ATTRIBUTES } from "../Constants";
import { ICartItems } from "../../../Interfaces/Cart";

export abstract class Choice extends AbstractSidebar {
    protected allowMultiselect = false;
    public static readonly ACTIVE_CLASS = "active";
    protected cartItems: ICartItems;
    protected optionalQuantityKey: string = "undefined";

    /**
     * add event listeners
     * @protected
     */
    protected addListeners(): this {
        super.addListeners();
        const choices = this.content.querySelectorAll("[data-choice]") as NodeListOf<HTMLElement>;
        Choice.addChoiceEventListeners(choices, this.allowMultiselect, this.content);
        return this;
    }

    static addChoiceEventListeners(
        choices: NodeListOf<HTMLElement>,
        allowMultiselect: boolean,
        content: HTMLElement
    ): void {
        choices.forEach((choice) => {
            choice.addEventListener("click", () => {
                if (allowMultiselect) {
                    this.updateMultiselectChoices(choice, content);
                } else {
                    choices.forEach((i) => i.classList.remove(Choice.ACTIVE_CLASS));
                    this.updateChoice(choice, content);
                }
            });
        });
    }

    static updateChoice(choice: HTMLElement, content: HTMLElement): void {
        choice.classList.add(Choice.ACTIVE_CLASS);
        const updated = choice.dataset.choice;
        if (updated === "") {
            content.dataset.choice = "";
        } else {
            content.dataset.choice = JSON.stringify([updated]);
        }
    }

    static updateMultiselectChoices(choice: HTMLElement, content: HTMLElement): void {
        choice.classList.toggle(Choice.ACTIVE_CLASS);
        const updated = Array.from(content.querySelectorAll<HTMLElement>(`div.${this.ACTIVE_CLASS}[data-choice]`)).map(
            (c) => c.dataset.choice
        );
        content.dataset.choice = JSON.stringify(updated);
    }

    /**
     * call callbacks that may be defined in additional-properties dataset of choice element
     * @param element
     * @param price
     * @private
     */
    protected updatePriceNode(element: HTMLElement, price: number) {
        const choice = element.closest<HTMLElement>(`[${DATA_ATTRIBUTES.CHOICE}]`);
        if (choice && choice.dataset.additionalProperties?.match(/javascript:calculateTax/)) {
            choice.dataset.additionalProperties = choice.dataset.additionalProperties.replace(
                /javascript:calculateTax/,
                calculateTax(choice, price)
            );
        }
    }

    /**
     * obtain user choice
     */
    public get choice(): string[] {
        const choice = this.content.dataset.choice || "[]";
        return JSON.parse(choice);
    }

    get quantity(): number {
        return Number(
            this.cartItems.items[0].properties?.[this.optionalQuantityKey] || this.cartItems.items[0].quantity
        );
    }
}
